import { View } from "./View";

export interface INotFoundPagesProps {
  pageType?: "default" | "payment-link";
  title?: string;
  message?: string;
  hideWhatCanYouDoMessage?: string;
}

export const NotFoundPages = (props: INotFoundPagesProps) => {
  return <View {...props} />;
};
